import {
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
  AfterViewInit,
  ViewChild,
  Input
} from '@angular/core';

import * as Swiper from 'swiper/dist/js/swiper.js';

import { AppState } from '../app.service';
import { AuthService } from '../auth/auth.service';
import { ResponsiveService } from '../responsive/responsive.service';
import { Subscription } from 'rxjs/Subscription';
import { ButtonModel } from '../buttons/models/button.model';
import { ButtonsService } from '../buttons/buttons.service';
import { CheckoutService } from '../checkout/checkout.service';
import { UIRouter } from '@uirouter/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HeaderComponent } from '../global/header/header.component';
import { ModalComponent } from '../global/modal/modal.component';
import { UserModel } from '../auth/models/user.model';
import { CheckoutItemModel } from '../checkout/models/item.model';

@Component({
  styleUrls: ['./home.component.scss'],
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit, OnDestroy, AfterViewInit {
  private responsiveSub: Subscription;
  private latestButtonsSub: Subscription;
  private userSub: Subscription;
  private currentUserSub: Subscription;

  @Input()
  public stateParams;

  @ViewChild(HeaderComponent)
  public headerComponent: HeaderComponent;

  @ViewChild('peopleSwiper')
  public peopleSwiperElement: ElementRef;

  public peopleSwiper;

  @ViewChild('partnerSwiper')
  public partnerSwiperElement: ElementRef;

  public partnerSwiper;

  @ViewChild('poetrySwiper')
  public poetrySwiperElement: ElementRef;

  public poetrySwiper;

  @ViewChild('video1Element')
  public video1Element: ElementRef;

  @ViewChild('video2Element')
  public video2Element: ElementRef;

  @ViewChild('video3Element')
  public video3Element: ElementRef;
  
  @ViewChild('modalComponentElement')
  public modalComponentElement: ModalComponent;

  public latestButtons: ButtonModel[] = [];
  private latestButtonsAll: ButtonModel[] = [];
  private latestButtonsOffset: number = 30;
  public showLoadMoreButtonsButton: boolean = false;
  public showHideButtonsButton: boolean = false;
  private latestButtonsSum: number = 0;

  public isVideoModalActive: boolean = false;

  public voucher = {
    code: null,
    isValid: null
  };

  public codeFocus: boolean = false;

  public videoRoot: string = 'https://d3l6ptb89vyf3h.cloudfront.net/videos';
  // public videoRoot: string = '/assets/video';

  public videoHeroHtml: SafeHtml;
  public videoButtonHtml: SafeHtml;
  public videoButtonBackgroundHtml: SafeHtml;
  public videoButtonsHtml: SafeHtml;
  public videoButtonsBackgroundHtml: SafeHtml;

  public isWindows: boolean = true;
  
  public modalButton: ButtonModel;
  public modalButtonImageUrl: string = '';
  public isOwnButton: boolean = false;
  public modalButtonIsRealButton: boolean = false;
  public currentUser: UserModel = null;

  public sharedButton: ButtonModel;
  private buttonSubscription: Subscription;

  constructor(
    private appState: AppState,
    private responsiveService: ResponsiveService,
    private buttonsService: ButtonsService,
    private checkoutService: CheckoutService,
    private router: UIRouter,
    private domSanitizer: DomSanitizer,
    private authService: AuthService
  ) { }

  private initPoetrySwiper() {
    if (this.poetrySwiperElement && !this.poetrySwiper) {
      this.poetrySwiper = new Swiper(this.poetrySwiperElement.nativeElement, {
        slidesPerView: 1,
        spaceBetween: 30,
        simulateTouch: false,
        autoHeight: true,
        pagination: {
          el: '.poetry .swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.poetry-swiper-container .swiper-button-next',
          prevEl: '.poetry-swiper-container .swiper-button-prev',
        }
      });
    }
  }

  private getPeopleSwiperSlidesPerView(width: number) {
    let slidesPerView;

    if (width < this.responsiveService.breakpoints.lg) {
      slidesPerView = 1.2;
    } else if (width < this.responsiveService.breakpoints.xl) {
      slidesPerView = 1.4;
    } else if (width < this.responsiveService.breakpoints.xxl) {
      slidesPerView = 1.6;
    } else {
      // yuuuuuge
      slidesPerView = 1.8;
    }

    return slidesPerView;
  }

  private resizeHeroVideo(data: {width: number, height: number}) {
    const videoElement = window.document.getElementById('hero_video');

    if (videoElement) {
      if (data.width >= videoElement.offsetWidth) {
        videoElement.style.width = '100vw';
        videoElement.style.height = 'auto';
      }

      if (data.height >= videoElement.offsetHeight) {
        videoElement.style.width = 'auto';
        videoElement.style.height = '100vh';
      }
    }
  }

  public ngOnInit() {
    if (this.stateParams.auth && this.stateParams.auth.redirect) {
      this.headerComponent.requestLogin(this.stateParams.auth.returnTo);
    }

    if (this.stateParams.code) {
      console.log(this.stateParams.code);

      this.buttonSubscription = this.buttonsService.getOne(this.stateParams.code)
      .subscribe(
        (result) => {
          this.sharedButton = result;
          this.openButtonModal(this.sharedButton, this.sharedButton.getSpiritualImageUrl());
        }
      );
    }

    // tslint:disable
    /**
     * For some reason videos don't autoplay if included directly in the Angular template.
     */
    // The hero loop ships with the site (src/assets/video) rather than from
    // videoRoot, so it changes with each deploy instead of on the shared CDN.
    this.videoHeroHtml = this.domSanitizer.bypassSecurityTrustHtml(`<video playsinline muted="muted" id="hero_video" class="Video" poster="/assets/img/video-poster.jpg" autoplay="autoplay" loop="loop">
        <source src="/assets/video/no_audio_hero_video.mp4" type="video/mp4" />
        <source src="/assets/video/no_audio_hero_video.webm" type="video/webm" />
      </video>`);

    // this.videoButtonHtml = this.domSanitizer.bypassSecurityTrustHtml(`<video playsinline muted="muted" id="video2" class="Video" preload="none" poster=" " autoplay="autoplay" loop="loop" style="height: 92px;">
    //     <source src="/assets/video/donate-buttons/test_button.mp4" type="video/mp4" />
    //   </video>`);
    this.videoButtonHtml = this.domSanitizer.bypassSecurityTrustHtml(`<video playsinline muted="muted" id="video2" class="Video" preload="none" poster=" " autoplay="autoplay" loop="loop">
        <source src="${this.videoRoot}/no_audio_3_bg_knopf_large.mp4" type="video/mp4" />
        <source src="${this.videoRoot}/no_audio_3_bg_knopf_large.webm" type="video/webm" />
      </video>`);
    this.videoButtonBackgroundHtml = this.domSanitizer.bypassSecurityTrustHtml(`<video playsinline muted="muted" id="video5" class="Video" preload="none" poster="/assets/img/bg-blue.png" autoplay="autoplay" loop="loop">
        <source [src]="${this.videoRoot}/no_audio_viceobck2.mp4" type="video/mp4" />
        <source [src]="${this.videoRoot}/no_audio_viceobck2.webm" type="video/webm" />
      </video>`);

    this.videoButtonsHtml = this.domSanitizer.bypassSecurityTrustHtml(`<video playsinline muted="muted" id="video3" class="Video" poster="/assets/img/multiple_buttons_video_fallback5.png" autoplay="autoplay" loop="loop">
        <source src="${this.videoRoot}/no_audio_1_bg_holeknopf_large.mp4" type="video/mp4" />
        <source src="${this.videoRoot}/no_audio_1_bg_holeknopf_large.webm" type="video/webm" />
      </video>`);
    this.videoButtonsBackgroundHtml = this.domSanitizer.bypassSecurityTrustHtml(`<video playsinline muted="muted" id="video4" class="Video" preload="none" poster="/assets/img/bg-blue.png" autoplay="autoplay" loop="loop">
        <source [src]="${this.videoRoot}/no_audio_viceobck2.mp4" type="video/mp4" />
        <source [src]="${this.videoRoot}/no_audio_viceobck2.webm" type="video/webm" />
      </video>`);
    // tslint:enable

    this.responsiveSub = this.responsiveService
      .resize
      .subscribe((data) => {
        this.resizeHeroVideo(data);

        if (data.width < 768) {
          this.initPoetrySwiper();
        } else {
          if (this.poetrySwiper) {
            this.poetrySwiper.destroy();
            this.poetrySwiper = undefined;
          }
        }

        if (this.peopleSwiper) {
          this.peopleSwiper.params.slidesPerView = this.getPeopleSwiperSlidesPerView(data.width);

          this.peopleSwiper.update();
        }
      });

    this.showHideLatestButtons('show');

    this.appState.change.subscribe(
      (change) => {
        if (change.property === 'isVideoModalActive') {
          this.isVideoModalActive = change.newValue;
        }
      }
    );

    this.isWindows = this.responsiveService.isWindows();

    this.currentUser = this.authService.currentUser;

    this.userSub = this.authService.currentUserChange.subscribe(
      (user) => {
        this.currentUser = user;
      }
    );
  }

  public ngOnDestroy() {
    this.responsiveSub.unsubscribe();
    this.latestButtonsSub.unsubscribe();
    this.userSub.unsubscribe();

    if (typeof this.currentUserSub !== 'undefined') {
      this.currentUserSub.unsubscribe();
    }

    if (typeof this.buttonSubscription !== 'undefined') {
      this.buttonSubscription.unsubscribe();
    }
  }

  public ngAfterViewInit() {
    setTimeout(() => {
      this.resizeHeroVideo({
        width: this.responsiveService.windowWidth,
        height: this.responsiveService.windowHeight
      });
    }, 0);

    this.peopleSwiper = new Swiper(this.peopleSwiperElement.nativeElement, {
      slidesPerView: this.getPeopleSwiperSlidesPerView(this.responsiveService.windowWidth),
      spaceBetween: 20,
      centeredSlides: true,
      loop: true,
      loopAdditionalSlides: 1,
      pagination: {
        el: '.people .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.people .swiper-button-next',
        prevEl: '.people .swiper-button-prev',
      },
      on: {
        init: () => {
          Array.prototype.slice.call(this.peopleSwiperElement.nativeElement.querySelectorAll('.swiper-slide')).forEach(slide => {
            slide.addEventListener('click', (evt) => {
              if (evt.target.parentElement.classList.contains('swiper-slide-prev') !== false) {
                this.peopleSwiper.slidePrev();
              }

              if (evt.target.parentElement.classList.contains('swiper-slide-next') !== false) {
                this.peopleSwiper.slideNext();
              }
            });
          });
        }
      }
    });

    this.partnerSwiper = new Swiper(this.partnerSwiperElement.nativeElement, {
      slidesPerView: 2,
      spaceBetween: 30,
      simulateTouch: false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        991: {
          slidesPerView: 2,
          spaceBetween: 30,
          centeredSlides: true,
        },
        767: {
          slidesPerView: 1.4,
          spaceBetween: 30,
          centeredSlides: true
        },
      }
    });

    if (this.responsiveService.windowWidth < 768) {
      this.initPoetrySwiper();
    }
  }

  public handleArrowDown() {
    setTimeout(() => {
      (document.querySelector('#section_2')).scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  public handleVoucherCheck() {
    if (this.voucher.code) {
      this.checkoutService.voucherCheck(this.voucher.code)
        .subscribe((result) => {
          this.voucher.isValid = result.isValid;

          if (this.voucher.isValid) {
            this.router.stateService.go('main.checkout.index', {code: this.voucher.code});
          }

          setTimeout(() => {
            this.voucher.isValid = null;
          }, 60000);
        });
    } else {
      this.router.stateService.go('main.checkout.index');
    }
  }

  public deactivateVideoModal() {
    this.appState.set('isVideoModalActive', false);
  }

  public showHideLatestButtons(showOrHide: string, event?: any) {
    if (showOrHide === 'hide') {
      let limit = (this.latestButtons.length - this.latestButtonsOffset) <= this.latestButtonsOffset ? this.latestButtonsOffset : (this.latestButtons.length - this.latestButtonsOffset);

      this.latestButtons = this.latestButtonsAll.slice(0, limit);
      this.showHideLoadAndHideButtons();
    } else if (showOrHide === 'show') {
      if (this.latestButtons.length === this.latestButtonsAll.length) {
        this.latestButtonsSub = this.buttonsService.getLatest(this.latestButtonsAll.length, (this.latestButtonsAll.length + this.latestButtonsOffset))
          .subscribe((result) => {
            this.latestButtonsAll = this.latestButtonsAll.concat(result);
            this.latestButtons = this.latestButtonsAll;

            result.forEach((button) => {
              if (button.scannedCount) {
                this.latestButtonsSum = button.scannedCount;
                return;
              }
            });

            this.showHideLoadAndHideButtons();
          });
      } else {
        this.latestButtons = this.latestButtonsAll.slice(0, (this.latestButtons.length + this.latestButtonsOffset));
        this.showHideLoadAndHideButtons();
      }
    }
  }

  private showHideLoadAndHideButtons() {
    if (this.latestButtons.length <= this.latestButtonsOffset) {
      this.showHideButtonsButton = false;
    } else {
      this.showHideButtonsButton = true;
    }

    if (this.latestButtons.length >= this.latestButtonsSum) {
      this.showLoadMoreButtonsButton = false;
    } else {
      this.showLoadMoreButtonsButton = true;
    }
  }

  public openButtonModal(button: ButtonModel, buttonImageUrl: string) {
    this.isOwnButton = false;
    this.modalButtonIsRealButton = false;
    this.modalButtonImageUrl = buttonImageUrl;
    this.modalButton = button;

    if (this.currentUser) {
      if (this.currentUser.id === button.user.id) {
        this.isOwnButton = true;
      }
    }

    if (button.design === 'weissgold') {
      this.modalButtonIsRealButton = true;
    }

    this.modalComponentElement.openModal();
  }

  public getDataToShare() {
    return {
      image: this.modalButtonImageUrl,
      title: 'Mut zur Phantasie',
      copy: `Das ist mein Knopf für mehr ${this.modalButton.spiritualText}. Wofür steht Deiner?`,
      buttonCode: this.modalButton.code,
      buttonHtmlLink: `${this.modalButton.code}`,
      shareAButton: true
    };
  }

  public handleGetSameButton(button: ButtonModel) {
    this.checkoutService.items.forEach((checkoutItem, index) => {
      if (checkoutItem.spiritual === '') {
        this.checkoutService.removeItem(checkoutItem, index);
      }
    });

    this.checkoutService.addItem(new CheckoutItemModel());

    let itemIndex = (this.checkoutService.items.length - 1);
    let item = this.checkoutService.items[itemIndex];

    item.design = button.design;
    item.spiritual = button.spiritual;

    if (button.user.options.displayAmounts !== 'no' && parseInt(button.value) > 0) {
      item.price = parseInt(button.value);
    } else {
      item.price = 1;
    }

    this.checkoutService.updateItem(item, itemIndex);
    this.router.stateService.go('main.checkout.index');
  }

  public handleRoutToProfile(evt: any) {
    evt.preventDefault();

    if (this.authService.currentUser) {
      this.router.stateService.go('main.auth.profile',
        {
          header:
          {
            backTo: 'main.home'
          }
        }
      );
    }

    if (typeof this.currentUserSub === 'undefined') {
      this.currentUserSub = this.authService.currentUserChange.subscribe(
        (result) => {
          if (!!result) {
            this.appState.set('isMenuActive', false);
            this.router.stateService.go('main.auth.profile',
              {
                header:
                {
                  backTo: 'main.home'
                }
              }
            );
          }
        }
      );
    }

    this.appState.set('isMenuActive', true);
  }
}


// WEBPACK FOOTER //
// ./src/app/home/home.component.ts